import { jsx } from 'react/jsx-runtime';
import { codeSyntaxHighlightLightMode, codeSyntaxHighlightDarkMode } from './codeSyntaxHighlight.js';
import { renderCssBasedOnColorScheme } from './renderCssBasedOnColorScheme.js';
import { lightThemeStylesheet, darkThemeStylesheet } from './variables.js';
import { Slot } from '@radix-ui/react-slot';
import { css, styled, ThemeProvider } from 'styled-components';

const RedefineThemeVariables = css([
  ``,
  ` `,
  ``
], renderCssBasedOnColorScheme({
  light: lightThemeStylesheet,
  dark: darkThemeStylesheet
}), renderCssBasedOnColorScheme({
  light: codeSyntaxHighlightLightMode,
  dark: codeSyntaxHighlightDarkMode
}));
const VarRedefined = styled.div.withConfig({
  displayName: "ForcedTheme__VarRedefined",
  componentId: "sc-81be42b6-0"
})([
  ``,
  ``
], RedefineThemeVariables);
const SlotRedefined = styled(Slot).withConfig({
  displayName: "ForcedTheme__SlotRedefined",
  componentId: "sc-81be42b6-1"
})([
  ``,
  ``
], RedefineThemeVariables);
const ForcedTheme = ({ colorScheme, children, asChild, disabled }) => {
  if (disabled || !colorScheme) {
    return children;
  }
  return /* @__PURE__ */ jsx(ThemeProvider, {
    theme: {
      userColorScheme: colorScheme
    },
    children: asChild ? /* @__PURE__ */ jsx(SlotRedefined, {
      children
    }) : /* @__PURE__ */ jsx(VarRedefined, {
      children
    })
  });
};

export { ForcedTheme };
//# sourceMappingURL=ForcedTheme.js.map
